import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { fnDom } from '../../../util/dom';


@Injectable()
export class FnMenuEventService {

  menuItemClick$ = new Subject<any>();
  menuOpen$ = new BehaviorSubject<boolean>(false);

  public navMenuClick(menuId: string) {
    const $this = fnDom('#' + menuId);
    if ($this.parents('li').hasClass('active')) {
      $this.parent('li').children('li').removeClass('active');
      $this.siblings('ul').children('li').removeClass('active');
      $this.parent('li').siblings('li').removeClass('active');
      $this.parents('li').addClass('active');
      // $this.parent('li').siblings('li').children('ul').slideUp();
      // $this.siblings('ul').children('li').children('ul').slideUp();
      // $this.siblings('ul').slideDown();
    } else {
      fnDom('.side-bar-menu li').each((node: any) => {
        fnDom(node).removeClass('active');
      });
      //  $('.side-bar-menu li ul').slideUp();
      $this.parents('li').addClass('active');
      // $this.siblings('ul').slideDown();
    }
  }

  onMenuItemClick(menuId: string,isChangeUrl=true): void {
    this.menuItemClick$.next({menuId,isChangeUrl});
    this.navMenuClick(menuId);
  }

  getMenuItemClick$() {
    return this.menuItemClick$;
  }

}
